document.addEventListener('DOMContentLoaded', () => {
  initReadMore();
  initAccordions();
  initPdpMedia();
});

document.addEventListener('shopify:section:load', () => {
  initReadMore();
  initAccordions();
  initPdpMedia();
});

function initReadMore() {
  document.querySelectorAll('[data-read-more]').forEach((details) => {
    if (details.dataset.casanaBound === 'true') return;
    details.dataset.casanaBound = 'true';

    const expanded = details.querySelector('.collection-intro-expanded');
    if (!expanded) return;

    if (expanded.scrollHeight <= 96) {
      details.remove();
    }
  });
}

function initAccordions() {
  document.querySelectorAll('.product-accordions').forEach((group) => {
    if (group.dataset.casanaBound === 'true') return;
    group.dataset.casanaBound = 'true';

    const accordions = group.querySelectorAll('.product-accordion');

    accordions.forEach((current) => {
      current.addEventListener('toggle', () => {
        if (!current.open) return;

        accordions.forEach((other) => {
          if (other !== current) other.removeAttribute('open');
        });
      });
    });
  });
}

function initPdpMedia() {
  document.querySelectorAll('media-gallery.pdp-media-gallery').forEach((gallery) => {
    if (gallery.dataset.casanaBound === 'true') return;
    gallery.dataset.casanaBound = 'true';

    const mediaList = gallery.querySelector('.product__media-list');
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const desktopMq = window.matchMedia('(min-width: 750px)');

    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const slide = entry.target;
          const video = ensureVideoLoaded(slide);

          if (!video) return;

          if (desktopMq.matches) {
            if (entry.isIntersecting) {
              playVideo(video);
            } else {
              pauseVideo(video);
            }
          }
        });
      },
      { threshold: 0.35 }
    );

    gallery.querySelectorAll('.product__media-item').forEach((slide) => {
      if (slide.querySelector('.deferred-media')) {
        videoObserver.observe(slide);
      }
    });

    const updateMobileActiveVideo = () => {
      if (desktopMq.matches) return;

      const activeSlide =
        gallery.querySelector('.product__media-item.is-active') ||
        gallery.querySelector('.product__media-item');

      gallery.querySelectorAll('video').forEach((video) => {
        const inActiveSlide = activeSlide && activeSlide.contains(video);
        if (inActiveSlide) {
          playVideo(video);
        } else {
          pauseVideo(video);
        }
      });

      if (activeSlide) {
        const activeVideo = ensureVideoLoaded(activeSlide);
        if (activeVideo) {
          playVideo(activeVideo);
        }
      }
    };

    updateMobileActiveVideo();

    if (viewer) {
      viewer.addEventListener('slideChanged', updateMobileActiveVideo);
    }

    if (mediaList) {
      let timer;
      mediaList.addEventListener(
        'scroll',
        () => {
          clearTimeout(timer);
          timer = setTimeout(updateMobileActiveVideo, 120);
        },
        { passive: true }
      );
    }

    desktopMq.addEventListener('change', updateMobileActiveVideo);
  });
}

function ensureVideoLoaded(slide) {
  if (!slide) return null;

  const deferred = slide.querySelector('.deferred-media');

  if (deferred && typeof deferred.loadContent === 'function' && !deferred.hasAttribute('loaded')) {
    deferred.loadContent(false);
  }

  return slide.querySelector('video');
}

function playVideo(video) {
  if (!video) return;

  video.muted = true;
  video.defaultMuted = true;
  video.autoplay = true;
  video.loop = true;
  video.playsInline = true;
  video.controls = false;

  video.removeAttribute('controls');
  video.setAttribute('muted', '');
  video.setAttribute('autoplay', '');
  video.setAttribute('loop', '');
  video.setAttribute('playsinline', '');

  const promise = video.play();
  if (promise && typeof promise.catch === 'function') {
    promise.catch(() => {});
  }
}

function pauseVideo(video) {
  if (!video) return;
  try {
    video.pause();
  } catch (e) {}
}